/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import React from 'react';
import _ from 'lodash';

import { Icon, Label, Step, StepGroup } from '@mairistem/composants';

import type { AssistantStep, Steps } from '@/types';
import { COLORS } from '@/constants';

interface Props {
  /**
   * Index de l'étape actuelle
   * 0 : Sélection
   * 1 : Verification des données
   */
  currentStepIndex: number;
  /** Toutes les étapes de l'assistant */
  steps: Partial<Record<Steps, AssistantStep>>;
  /** Callback appelé lors du changement d'étape */
  onStepChange: (stepIndex: Steps) => void;
}

const AssistantHeader = (props: Props) => {
  // #region Declarations
  const { currentStepIndex, steps, onStepChange } = props;

  // #endregion

  // #region Component

  return (
    <StepGroup
      fluid
      className="connected"
      style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
    >
      {_.map(steps, (step: AssistantStep, index: Steps) => {
        const { title, dataTestId, validated = false } = step;

        const stepIndex: Steps = Number(index);
        const displayNumber = Object.keys(steps).indexOf(String(stepIndex)) + 1;

        const isDisabled = false;

        const content: React.ReactNode = (
          <Label
            circular
            size="big"
            style={{
              backgroundColor:
                stepIndex <= currentStepIndex ? COLORS.Background : 'white',
              border: `solid 1px ${COLORS.HeaderStepBorder}`,
              color:
                stepIndex <= currentStepIndex ? 'white' : COLORS.Background,
            }}
          >
            {displayNumber}
            {(validated || stepIndex < currentStepIndex) && (
              <Icon
                name="checkmark"
                style={{
                  position: 'absolute',
                  top: '40%',
                  left: '55%',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  color: 'green',
                  width: 17,
                  height: 20,
                }}
              />
            )}
          </Label>
        );

        return (
          <Step
            key={title}
            style={{
              backgroundColor: 'transparent',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1,
            }}
            data-testid={dataTestId}
            onClick={() => !isDisabled && onStepChange(stepIndex)}
          >
            <Step.Content style={{ bottom: '0.6em' }}>
              {content}
              <Step.Title style={{ paddingTop: 5, color: COLORS.Background }}>
                {title}
              </Step.Title>
            </Step.Content>
          </Step>
        );
      })}
    </StepGroup>
  );
};

export default AssistantHeader;
